<template>
  <div
    class="conversations-list-wrap"
    :class="{
      hide: !showConversationList,
      'list--full-width': isOnExpandedLayout,
    }"
  >
    <slot />
    <div class="chat-list__top">
      <div class="flex-center">
        <woot-sidemenu-icon />

        <h1 class="page-title text-truncate" :title="pageTitle">
          {{ pageTitle }}
        </h1>
      </div>
    </div>

    <div class="boards-conversations">
      <chat-list-grouped
        v-for="(board, index) in boards"
        :key="index"
        :conversation-inbox="conversationInbox"
        :team-id="teamId"
        :label="label"
        :conversation-type="conversationType"
        :folders-id="foldersId"
        :showConversation-list="showConversationList"
        :is-on-expanded-layout="isOnExpandedLayout"
        :status="status"
        :board="board"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ChatListGrouped from './ChatListGrouped';

export default {
  components: {
    ChatListGrouped,
  },
  props: {
    conversationInbox: {
      type: [String, Number],
      default: 0,
    },
    teamId: {
      type: [String, Number],
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    conversationType: {
      type: String,
      default: '',
    },
    foldersId: {
      type: [String, Number],
      default: 0,
    },
    showConversationList: {
      default: true,
      type: Boolean,
    },
    isOnExpandedLayout: {
      default: false,
      type: Boolean,
    },
    boardType: {
      type: String
    },
    status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      boards: []
    };
  },
  watch: {
    boardType: {
      async handler() {
        await this.initBoards();
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      activeInbox: 'getSelectedInbox',
      inboxes: 'inboxes/getInboxes',
      teams: 'teams/getTeams',
      currentRole: 'getCurrentRole',
      myTeams: 'teams/getMyTeams',
    }),
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.activeInbox);
    },
    pageTitle() {
      if (this.inbox.name) {
        return this.inbox.name;
      }
      if (this.activeTeam.name) {
        return this.activeTeam.name;
      }
      if (this.label) {
        return `#${this.label}`;
      }
      if (this.conversationType === 'mention') {
        return this.$t('CHAT_LIST.MENTION_HEADING');
      }
      return this.$t('CHAT_LIST.TAB_HEADING');
    },
    activeTeam() {
      if (this.teamId) {
        return this.$store.getters['teams/getTeam'](this.teamId);
      }
      return {};
    },
  },
  mounted() {
  },
  methods: {
    async initBoards(){
      if(this.boardType == 'status'){
        if(this.teams.length == 0){
          this.$store.dispatch('teams/get');
        }
        if(this.inboxes.length == 0){
          this.$store.dispatch('inboxes/get');
        }
      }else{
        if(this.boardType == 'teams' && this.teams.length == 0){
          await this.$store.dispatch('teams/get');
        }
        if(this.boardType == 'inboxes' && this.inboxes.length == 0){
          await this.$store.dispatch('inboxes/get');
        }
      }
      let teams = this.myTeams.map((team) => ({
        key: 'teams',
        title: team.name,
        value: team.id,
        filter_key: 'teamId',
      }));
      if(this.currentRole == 'administrator'){
        teams.unshift({ 
          key: 'teams',
          title: this.$t('CHAT_LIST.BOARD_HEADER_UNASSIGNED_TEAM'),
          value: 0,
          filter_key: 'teamId'
        });
      }
      
      let boards = {
        'status': ['pending', 'snoozed', 'open', 'resolved'].map((status) => ({
          key: 'status',
          title: this.$t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${status}.TEXT`),
          value: status,
          filter_key: 'status',
        })),
        'teams': teams,
        'inboxes': this.inboxes.map((inbox) => ({
          key: 'inboxes',
          title: inbox.name,
          value: inbox.id,
          filter_key: 'inboxId',
        })),
      }
      this.boards =  boards[this.boardType] || [];
    }
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/woot';

.spinner {
  margin-top: var(--space-normal);
  margin-bottom: var(--space-normal);
}

.boards-conversations {
  display: flex;
  padding-left: 10px;
  height: 100%;
  position: relative;
  padding-right: 10px;
  padding-bottom: 0;
  overflow-x: auto;
  overflow-y: hidden;
}

.conversations-list {
  // Prevent the list from scrolling if the submenu is opened
  &.is-context-menu-open {
    overflow: hidden !important;
  }
}

.conversations-list-wrap {
  flex-shrink: 0;
  width: 34rem;
  overflow: hidden;
  @include breakpoint(large up) {
    width: 36rem;
  }
  @include breakpoint(xlarge up) {
    width: 35rem;
  }
  @include breakpoint(xxlarge up) {
    width: 38rem;
  }
  @include breakpoint(xxxlarge up) {
    flex-basis: 46rem;
  }

  &.hide {
    display: none;
  }

  &.list--full-width {
    width: 100%;
    @include breakpoint(xxxlarge up) {
      flex-basis: 100%;
    }
  }
}
.filter--actions {
  display: flex;
  align-items: center;
}

.btn-filter {
  margin: 0 var(--space-smaller);
}

.filter__applied {
  padding: 0 0 var(--space-slab) 0 !important;
  border-bottom: 1px solid var(--color-border);
}

.delete-custom-view__button {
  margin-right: var(--space-normal);
}
</style>
